import { createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 親なしサブコレクションの削除 ")
const _hoisted_2 = { class: "space-y-4 text-sm" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "学校", -1)
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "教室", -1)
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "パス", -1)
const _hoisted_9 = { class: "break-all font-mono" }
const _hoisted_10 = { class: "mt-2 text-gray-600" }
const _hoisted_11 = {
  key: 0,
  class: "bg-yellow-50 border border-yellow-300 rounded-md p-3"
}
const _hoisted_12 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_13 = { class: "bg-gray-50 rounded-md p-3 text-center" }
const _hoisted_14 = { class: "text-2xl font-bold" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "削除される文書", -1)
const _hoisted_16 = { class: "bg-gray-50 rounded-md p-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500 mb-1" }, " 残っているサブコレクション ", -1)
const _hoisted_18 = { class: "font-mono break-all" }
const _hoisted_19 = { class: "bg-red-50 border border-red-300 rounded-md p-3 text-red-700" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "font-bold" }, "この操作は取り消せません。", -1)
const _hoisted_21 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_22 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 閉じる ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 削除を実行 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 閉じる ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MButton = _resolveComponent("MButton")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    size: "wide",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", null, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.preview.schoolName || "（名前が見つかりません）"), 1)
          ]),
          _createVNode("div", null, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.preview.classroomName || "（名前が見つかりません）"), 1)
          ])
        ]),
        _createVNode("div", null, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.preview.path), 1)
        ]),
        _createVNode("div", null, [
          _createVNode("span", {
            class: ["inline-block px-3 py-1 rounded-full text-sm font-medium", _ctx.categoryBadgeClass]
          }, _toDisplayString(_ctx.categoryLabel), 3),
          _createVNode("p", _hoisted_10, _toDisplayString(_ctx.categoryDescription), 1)
        ]),
        (!_ctx.preview.deletable)
          ? (_openBlock(), _createBlock("div", _hoisted_11, " 削除できません: " + _toDisplayString(_ctx.reasonLabel(_ctx.preview.reason)), 1))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.preview.docCount) + _toDisplayString(_ctx.preview.truncated ? "件以上" : "件"), 1),
                  _hoisted_15
                ]),
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, _toDisplayString(_ctx.preview.subcollections.join("、")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                (_ctx.preview.category === 'ownerless')
                  ? (_openBlock(), _createBlock("p", _hoisted_21, " 所有者が見つからないデータです。内容を確認してから実行してください。 "))
                  : _createCommentVNode("", true),
                (_ctx.preview.truncated)
                  ? (_openBlock(), _createBlock("p", _hoisted_22, " 文書が多いため、件数は途中までの数えです。実行はできません。 "))
                  : _createCommentVNode("", true)
              ])
            ], 64)),
        (_ctx.result)
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              class: ["rounded-md p-3", _ctx.resultClass]
            }, _toDisplayString(_ctx.resultMessage), 3))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      (!_ctx.result)
        ? (_openBlock(), _createBlock(_component_MButton, {
            key: 0,
            text: "",
            color: "gray-600",
            class: "mr-4",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.preview.deletable && !_ctx.preview.truncated && !_ctx.result)
        ? (_openBlock(), _createBlock(_component_MButton, {
            key: 1,
            color: "red-600",
            disabled: !_ctx.canExecute,
            onClick: _ctx.confirmAndExecute
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.result)
        ? (_openBlock(), _createBlock(_component_MButton, {
            key: 2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}